import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Panel" }


import InnSection from "@/components/general/Section.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Panel',
  props: {
    title: {
        type: String,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InnSection, null, {
      default: _withCtx(() => [
        _createElementVNode("h2", null, _toDisplayString(__props.title), 1)
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})